import { BasePermission } from "@fartherfinance/frontend/api/Types";

export const initialState = {
  modelTable: [],
  modelName: undefined,
  firm: undefined,
  series: undefined,
  allocation: undefined,
  taxType: undefined,
  basePermission: "Private" as BasePermission,
  assetCategoriesWithClasses: [],
};
